export default "__VITE_PUBLIC_ASSET__f663b4c7__"